export function SET_MESSAGE_ID({ commit }, [message_id]) {
    commit('SAVE_MESSAGE_ID', [message_id])
}

export function SET_BADGE_ID({ commit }, [badge_id]) {
    commit('SAVE_BADGE_ID', [badge_id])
}

export function SET_NEWS_ID({ commit }, [news_id]) {
    commit('SAVE_NEWS_ID', [news_id])
}